// @ts-ignore
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Aplicaciones} from "../recursos/modelo/Aplicaciones";
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";

declare var swal: any;
declare const $: any;


@Component({
    selector: 'cmp-complementos',
    templateUrl: './view/cmp-complementos.component.html',
    styleUrls: ['./css/cmp-complementos.component.scss']
})
export class CmpComplementosComponent implements OnInit, OnChanges {

    @Input() aplicaciones;
    @Input() emisor;

    downloadRetail64 = "";
    downloadRetail32 = "";
    downloadPrinter64 = "";
    downloadPrinter32 = "";
    empresaAdmin = false;


    constructor(private util: UtilConfig) {
        let empresa = this.util.getCurrentUser().customer.id;
        if (empresa.toString() == this.util.ESCON_CUSTOMER.toString()) {
            this.empresaAdmin = true;
        }

        this.downloadRetail32 = this.util.URL_WS_BACKEND + WebServices.URL_DOWNLOAD_RETAIL_32 + "?authorization=" + this.util.getJwtToken();
        this.downloadRetail64 = this.util.URL_WS_BACKEND + WebServices.URL_DOWNLOAD_RETAIL_64 + "?authorization=" + this.util.getJwtToken();
        this.downloadPrinter32 = this.util.URL_WS_BACKEND + WebServices.URL_DOWNLOAD_PRINTER_32 + "?authorization=" + this.util.getJwtToken();
        this.downloadPrinter64 = this.util.URL_WS_BACKEND + WebServices.URL_DOWNLOAD_PRINTER_64 + "?authorization=" + this.util.getJwtToken();
    }

    ngOnInit() {
    }


    ngOnChanges(changes: SimpleChanges) {
        this.validarAplicaciones();
    }


    validarAplicaciones() {

        if (this.emisor)
            $.each(this.emisor.applications, (pos, item) => {
                if (Aplicaciones.ADMINISTRADOR == item)
                    this.emisor.posee_ADMIN = true;

                if (Aplicaciones.VALIDADOR == item)
                    this.emisor.posee_VALIDADOR = true;

                if (Aplicaciones.TRANSFORMADOR == item)
                    this.emisor.posee_PSE = true;

                if (Aplicaciones.EMISOR == item)
                    this.emisor.posee_EMISOR = true;

                if (Aplicaciones.RETAIL == item)
                    this.emisor.posee_RETAIL = true;

                if (Aplicaciones.PRINT == item)
                    this.emisor.posee_PRINT = true;

                if (Aplicaciones.THIRDS == item)
                    this.emisor.posee_TERCEROS = true;
            });
    }

    agregarTercero() {
        this.emisor.applications.push(Aplicaciones.THIRDS);
        this.emisor.posee_TERCEROS = true;
    }

    agregarPSE() {
        this.emisor.applications.push(Aplicaciones.TRANSFORMADOR);
        this.emisor.posee_PSE = true;
    }

    agregarEMISOR() {
        this.emisor.applications.push(Aplicaciones.EMISOR);
        this.emisor.posee_EMISOR = true;
    }

    agregarVALIDADOR() {
        this.emisor.applications.push(Aplicaciones.VALIDADOR);
        this.emisor.posee_VALIDADOR = true;
    }

    agregarADMIN() {
        this.emisor.applications.push(Aplicaciones.ADMINISTRADOR);
        this.emisor.posee_ADMIN = true;
    }


    agregarRETAIL() {
        this.emisor.applications.push(Aplicaciones.RETAIL);
        this.emisor.posee_RETAIL = true;
    }

    agregarPRINT() {

        this.emisor.applications.push(Aplicaciones.PRINT);
        this.emisor.posee_PRINT = true;
    }

    quitarRETAIL() {
        let posComponente = 0;
        $.each(this.emisor.applications, (pos, item) => {
            if (Aplicaciones.RETAIL == item)
                posComponente = pos;
        });

        this.emisor.applications.splice(posComponente, 1);
        this.emisor.posee_RETAIL = false;
    }

    quitarPRINT() {
        let posComponente = 0;
        $.each(this.emisor.applications, (pos, item) => {
            if (Aplicaciones.PRINT == item)
                posComponente = pos;
        });

        this.emisor.applications.splice(posComponente, 1);
        this.emisor.posee_PRINT = false;
    }

    quitarTercero() {
        let posComponente = 0;
        $.each(this.emisor.applications, (pos, item) => {
            if (Aplicaciones.THIRDS == item)
                posComponente = pos;
        });
        this.emisor.applications.splice(posComponente, 1);
        this.emisor.posee_TERCEROS = false;
    }

    quitarPSE() {
        let posComponente = 0;
        $.each(this.emisor.applications, (pos, item) => {
            if (Aplicaciones.TRANSFORMADOR == item)
                posComponente = pos;
        });
        this.emisor.applications.splice(posComponente, 1);
        this.emisor.posee_PSE = false;
    }

    quitarEMISOR() {
        let posComponente = 0;
        $.each(this.emisor.applications, (pos, item) => {
            if (Aplicaciones.EMISOR == item)
                posComponente = pos;
        });

        this.emisor.applications.splice(posComponente, 1);
        this.emisor.posee_EMISOR = false;
    }

    quitarVALIDADOR() {
        let posComponente = 0;
        $.each(this.emisor.applications, (pos, item) => {
            if (Aplicaciones.VALIDADOR == item)
                posComponente = pos;
        });

        this.emisor.applications.splice(posComponente, 1);
        this.emisor.posee_VALIDADOR = false;
    }

    quitarADMIN() {
        let posComponente = 0;
        $.each(this.emisor.applications, function (pos, item) {
            if (Aplicaciones.ADMINISTRADOR == item)
                posComponente = pos;
        });

        this.emisor.applications.splice(posComponente, 1);
        this.emisor.posee_ADMIN = false;
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-complementos/cmp-complementos.component.ts